module.exports = __webpack_public_path__ + "img/Cleric.d8288392.png";